import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

function RestrictiveRevertCard(): JSX.Element {
  return (
    <div className={css(styles.cardContainer)}>
      <BenchlingIcon icon="lock" className={css(styles.icon)} />
      <div>Resetting to a version before a table submission is not allowed.</div>
    </div>
  );
}

const styles = StyleSheet.create({
  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    color: Color.GRAY_700,
    borderTop: `1px solid ${Color.GRAY_400}`,
    size: '11px',
    padding: '8px 15px 8px 10px',
  },
  icon: {
    width: 12,
    height: 12,
    color: Color.GRAY_400,
  },
});

export default RestrictiveRevertCard;
